module.exports = __webpack_public_path__ + "static/media/Yesterday-logo.2deeee23.png";